'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp2;

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _WixRestErrorResponse = require('./WixRestErrorResponse.less');

var _WixRestErrorResponse2 = _interopRequireDefault(_WixRestErrorResponse);

var _OrderError = require('../../icons/OrderError');

var _OrderError2 = _interopRequireDefault(_OrderError);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = (_temp2 = _class = function (_React$Component) {
    (0, _inherits3.default)(_default, _React$Component);

    function _default() {
        var _ref;

        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, _default);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = _default.__proto__ || (0, _getPrototypeOf2.default)(_default)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
            showErrorType: ''
        }, _this._buttonRef = function (el) {
            var doneButtonRef = _this.props.doneButtonRef;

            _this.button = el;
            doneButtonRef(el);
        }, _this._getDescriptions = function () {
            var descriptions = _this.props.descriptions;

            var res = descriptions;

            if (typeof descriptions === 'string' || descriptions instanceof String) {
                res = [descriptions];
            }

            return res;
        }, _this._onIconClick = function () {
            if (_this.state.showErrorType) {
                _this.setState({
                    showErrorType: false
                });
            } else {
                _this.setState({
                    showErrorType: true
                });
            }
        }, _this._onButtonClick = function (e) {
            var onButtonClick = _this.props.onButtonClick;

            onButtonClick && onButtonClick();
            e.preventDefault();
        }, _this._onButtonKeyDown = function (e) {
            _this.props.onButtonKeyDown(e);
        }, _this.focus = function () {
            if (_this.button) {
                _this.button.focus();
            }
        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    (0, _createClass3.default)(_default, [{
        key: 'render',
        value: function render() {
            var showErrorType = this.state.showErrorType;
            var _props = this.props,
                errorType = _props.errorType,
                title = _props.title,
                button = _props.button,
                ccMessage = _props.ccMessage,
                styleModule = _props.styleModule,
                titleId = _props.titleId,
                descriptionId = _props.descriptionId;

            var descriptions = this._getDescriptions();
            var description1 = descriptions[0];
            var description2 = descriptions.length > 1 ? descriptions[1] : null;

            return _react2.default.createElement(
                'div',
                { className: _WixRestErrorResponse2.default.wrapper + ' ' + styleModule.wrapper },
                _react2.default.createElement(
                    'div',
                    { className: _WixRestErrorResponse2.default.header + ' ' + styleModule.header },
                    _react2.default.createElement(
                        'div',
                        { className: _WixRestErrorResponse2.default.icon + ' ' + styleModule.icon, onDoubleClick: this._onIconClick },
                        _react2.default.createElement(_OrderError2.default, null)
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: _WixRestErrorResponse2.default.technicalCode },
                        showErrorType ? errorType : null
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: _WixRestErrorResponse2.default.body + ' ' + styleModule.body },
                    _react2.default.createElement(
                        'div',
                        { className: _WixRestErrorResponse2.default.title + ' ' + styleModule.title, id: titleId },
                        title
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: _WixRestErrorResponse2.default.description + ' ' + styleModule.description, id: descriptionId },
                        description1,
                        description2 ? _react2.default.createElement(
                            'div',
                            null,
                            description2
                        ) : null
                    ),
                    _react2.default.createElement(
                        'button',
                        { ref: this._buttonRef, className: _WixRestErrorResponse2.default.button + ' ' + styleModule.button, onClick: this._onButtonClick, onKeyDown: this._onButtonKeyDown },
                        button
                    ),
                    ccMessage ? _react2.default.createElement(
                        'div',
                        { className: _WixRestErrorResponse2.default.ccMessage + ' ' + styleModule.ccMessage },
                        ccMessage
                    ) : null
                )
            );
        }
    }]);
    return _default;
}(_react2.default.Component), _class.displayName = 'WixRestErrorResponse', _class.propTypes = {
    errorType: _propTypes2.default.string,
    title: _propTypes2.default.string.isRequired,
    descriptions: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.arrayOf(_propTypes2.default.string)]).isRequired,
    button: _propTypes2.default.string.isRequired,
    ccMessage: _propTypes2.default.string,
    onButtonClick: _propTypes2.default.func,
    styleModule: _propTypes2.default.object,
    onButtonKeyDown: _propTypes2.default.func,
    doneButtonRef: _propTypes2.default.func,
    titleId: _propTypes2.default.string,
    descriptionId: _propTypes2.default.string
}, _class.defaultProps = {
    extraMessage: '',
    onButtonKeyDown: function onButtonKeyDown() {},
    doneButtonRef: function doneButtonRef() {},
    titleId: '',
    descriptionId: ''
}, _temp2);

exports.default = _default;